import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '@/api';
import { analyticsKeys } from '@/lib/queryKeys';
import { GC_TIMES, POLL_INTERVALS, STALE_TIMES } from '@/lib/constants';

export function useConversions(periodDays: number, identityId?: string) {
  return useQuery({
    queryKey: analyticsKeys.conversions(periodDays, identityId),
    queryFn: () => analyticsApi.conversions(periodDays, identityId),
    staleTime: STALE_TIMES.veryLong,
    gcTime: GC_TIMES.long,
    refetchInterval: (query) =>
      query.state.status !== 'error' && query.state.data?.status === 'LOADING'
        ? POLL_INTERVALS.conversionsSync
        : false,
    refetchIntervalInBackground: false,
  });
}
